/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderXIcon16Solid = forwardRef('FolderXIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 3.5A1.5 1.5 0 0 1 2.5 2h3.3a1.5 1.5 0 0 1 1.205.607L8.037 4H12.5A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5v-8Zm9.68 4.022A.85.85 0 0 0 9.48 6.319L8 7.8l-1.479-1.48A.85.85 0 0 0 5.32 7.522L6.798 9 5.319 10.48a.85.85 0 1 0 1.202 1.202L8 10.202l1.479 1.479a.85.85 0 1 0 1.202-1.202L9.202 9l1.479-1.478Z" })));
});
